import { apiUrl } from "../utils/api";

/**
 * T-216: Der erkannte Text eines Dokuments („Text kopieren“ im PDF-Editor).
 * Eigene kleine Datei statt `documentService`, damit die Editor-Tests keine
 * weiteren Mocks brauchen.
 */
export type ErkannterTextZustand = "ok" | "leer" | "offen" | "laeuft" | "fehler" | "nichtUnterstuetzt" | "zuGross";

export interface ErkannterText {
    zustand: ErkannterTextZustand;
    text?: string;
    methode?: "tika" | "ocr" | "none";
    erkanntAm?: string | null;
    /** Passt der Text zur heutigen Datei? `null` = unbekannt (wie „passt“ behandeln). */
    aktuell?: boolean | null;
}

const fehlerText = (status: number): string =>
    status === 404
        ? "Das Dokument wurde nicht gefunden oder Sie dürfen es nicht öffnen."
        : status === 403
          ? "Dafür fehlt Ihnen die Berechtigung."
          : `Der Text konnte nicht geladen werden (Fehler ${status}).`;

export const erkannterTextService = {
    async laden(docId: number, signal?: AbortSignal): Promise<ErkannterText> {
        const res = await fetch(apiUrl(`documents/${docId}/text`), { signal });
        if (!res.ok) throw new Error(fehlerText(res.status));
        return res.json();
    },
    async erkennen(docId: number): Promise<ErkannterText> {
        const res = await fetch(apiUrl(`documents/${docId}/text/erkennen`), { method: "POST" });
        if (!res.ok) throw new Error(fehlerText(res.status));
        return res.json();
    },
};
